import React from 'react';

import Heading from '@atlaskit/heading';

import { Flex } from '@atlaskit/primitives';

export const List = ({
	heading,
	description,
	children,
}: {
	heading: string;
	description: React.ReactNode;
	children?: React.ReactNode;
}) => (
	<Flex direction="column" rowGap="space.300">
		<Flex rowGap="space.100" direction="column">
			<Heading size="xxlarge">{heading}</Heading>
		</Flex>
		<Flex role="list" direction="column" rowGap="space.150">
			{description}
			{children}
		</Flex>
	</Flex>
);
